export default __webpack_public_path__ + "static/media/hubofallthings-white.49c46be4.svg";